/** ========================================================================
 * * Radio Component
 * This component renders a selection radio.
 * ========================================================================== */

export default function Radio({ options, selected, onClick }) {
  /* ====================== CLASSNAMES ====================== */
  const classNames = (option) => {
    let classes = `p-2 rounded-lg border border-stone-600 text-xs lg:text-sm cursor-pointer font-semibold `;
    if (option.toLowerCase() === selected) classes += "bg-stone-600 text-white";
    else classes += "text-stone-400";
    return classes;
  };

  /* ====================== CLICK HANDLER ====================== */
  const clickHandler = (option) => {
    onClick && onClick(option.toLowerCase());
  };

  return options.map((option, index) => {
    if (typeof option === "string")
      return (
        <div
          className={classNames(option)}
          onClick={() => clickHandler(option)}
          key={index}
        >
          <p className="text-center">{option}</p>
        </div>
      );
      else return (
        <div
          className={classNames(option.id)}
          onClick={() => clickHandler(option.id)}
          key={index}
        >
          <p className="text-center">{option.name}</p>
        </div>
      )
  });
}
